/**
 * @author Dat Doan
 * @date 2021-04-16
 * @param {HTMLElement} node
 * @param {boolean} trigger
 * @returns {object}
 */
export function focusOnTrigger(node, trigger) {
  function focusElement(trigger) {
    if (trigger) {
      node.focus();
      node.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  }

  focusElement(trigger);

  return {
    update(newHidden) {
      trigger = newHidden;
      focusElement(trigger);
    },
  };
}
